import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectRoutingModule } from './select-routing.module';
import { SelectButtonComponent } from './selectButton.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {SelectButtonModule} from "../../component/ing/selectbutton/selectbutton";
import {TableModule} from "../../component/ing/table/table";

@NgModule({
  imports: [
    CommonModule,
    SelectRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    SelectButtonModule,
    TableModule,
    FormsModule
  ],
  declarations: [
  	SelectButtonComponent
  ]
})
export class SelectButtonDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/selectButton/selectButtonDemo.module.ts